<template>
  <dialogComp :hideCloseBtn="true" :zIndex="10000" ref="dialog">
    <div class="clause-content-box">
      <div id="ruleBox" class="clause-content">
        <div class="textArea">
          <p class="tit">#追空投的那些事#</p>
          <textarea
            placeholder="点击输入话题"
            name=""
            id=""
            cols="30"
            rows="10"
            v-model="shareTxt"
          ></textarea>
          <p class="des">至少上传1张照片，文案10字以上</p>
        </div>
        <div class="uploadBox">
          <div class="upload">
            <div
              class="upload-i"
              v-for="(item, index) in uploadList"
              :key="index"
            >
              <img v-if="item.src" :src="item.src" alt="" />
              <div v-else class="chooseBtn">
                <img
                  src="https://source.qunarzz.com/site/images/wns/20220726-shijianchen-peace-upload.png"
                  alt=""
                />
                <input
                  @change="
                    (e) => {
                      changeFile(e, index);
                    }
                  "
                  class="file"
                  type="file"
                />
              </div>
            </div>
          </div>
        </div>
        <img
          @click="submit"
          src="https://source.qunarzz.com/site/images/wns/20220726-shijianchen-peace-submit.png"
          class="uploadBtn"
          alt=""
        />
      </div>
      <img
        @click="close"
        src="https://source.qunarzz.com/site/images/wns/20220726-shijianchen-peace-close.png"
        class="closeBtn"
        alt=""
      />
    </div>
  </dialogComp>
</template>
<script>
import dialogComp from '@/components/dialog/index.vue';
import { Button } from 'mint-ui';
import loginDialog from '../login/index';
import giftDialog from '../gift/index';
export default {
  components: {
    dialogComp,
    'mt-button': Button,
  },
  data() {
    return {
      text: '',
      shareTxt: '',
      type:'1',
      uploadList: [
        {
          src: '',
          fileKey: '',
        },
        {
          src: '',
          fileKey: '',
        },
        {
          src: '',
          fileKey: '',
        },
      ],
    };
  },
  mounted() {
    Indicator.open();
  },
  methods: {
    show() {
      this.uploadList = [
        {
          src: '',
          fileKey: '',
        },
        {
          src: '',
          fileKey: '',
        },
        {
          src: '',
          fileKey: '',
        },
      ];
      this.shareTxt = ''
      this.text = ''
      this.$refs.dialog.show();
    },
    addNum(type) {
      this.$axios.get('/commonly/getchannelnum?source=' + type).then(() => {
        this.callback();
      });
    },
    submit() {
      let files = [];
      let params = {};
      this.uploadList.forEach((item) => {
        if (item.src) {
          files.push(item.fileKey);
        }
      });
      if (files.length == 0) {
        this.$dialog.alert({
          message: '至少上传1张照片，文案10字以上',
        });
        return;
      }
      if(this.shareTxt.length<=10){
        this.$dialog.alert({
          message: '至少上传1张照片，文案10字以上',
        });
        return;
      }
      params.fileKeys = files.join(',');
      params.shareTxt = this.text + this.shareTxt;
      this.$http({
        url: '/commonly/shareMessage',
        type: 'post',
        data: params,
        config: { formType: true },
        login: loginDialog,
        success: (res) => {
          this.$dialog.alert({
            message: '上传成功',
          });
          this.type == '2' && this.addNum('sc');
        },
      });
    },
    close() {
      this.$refs.dialog.close();
    },
    changeFile(e, index) {
      let file = e.target.files[0];
      let formData = new FormData();
      let videoData = new FormData();
      formData.append('shareFile', file);
      videoData.append('videoFile', file);
      let imgSrc = window.URL.createObjectURL(file);
      this.$http({
        url: '/commonly/picUpload',
        type: 'post',
        data: formData,
        config: { formType: false },
        login: loginDialog,
        success: (res) => {
          this.$set(this.uploadList, index, {
            src: imgSrc,
            type: file.type == 'video/mp4' ? 'video' : 'img',
            fileKey: res.data.fileKey,
          });
        },
      });
    },
  },
};
</script>

<style lang="less" scoped="true">
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.rule-tit {
  .rem(font-size,14);
  .rem(margin-bottom,12);
  font-weight: bold;
}
.rule-box {
  .rem(margin-bottom,12);
}
.clause-content-box {
  width: 272px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  max-height: 271px;
  position: relative;
  background: url(https://source.qunarzz.com/site/images/wns/20220726-shijianchen-peace-back.png)
    no-repeat;
  background-size: 100% auto;
  padding-top: 10px;
  strong {
    color: #fff;
  }
  .clause-title {
    color: #fff;
    font-size: 0.4rem;
    width: 100%;
    padding-bottom: 20px;
    display: flex;
    align-items: center;
    position: relative;
    img {
      width: 82px;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .rule-close {
      width: 16px;
      position: absolute;
      right: 10px;
      top: -10px;
    }
  }
  .rule-title {
    color: #fad483;
  }
  .clause-content {
    height: 220px;
    line-height: 2;
    width: 190px;
    margin-left: auto;
    margin-right: auto;
    overflow: auto;
    .rem(font-size,10);
    color: #fff;
  }
}
.strong {
  font-weight: bold;
}
.textArea {
  width: 100%;
  background-color: #fff;
  padding: 5px 8px;
  box-sizing: border-box;
  p {
    color: #6e6e6e;
  }
  textarea {
    height: 34px;
    display: block;
    width: 100%;
    border: none;
    font-size: 10px;
  }
  .tit {
    font-size: 10px;
    color: #2d38c2;
    font-weight: bold;
  }
  .des {
    text-align: right;
    font-size: 7px;
  }
}
.chooseBtn {
  width: 59px;
  height: 58px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  img {
    width: 22px !important;
    height: 22px !important;
  }
}
.uploadBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 7px;
}
.file {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 2;
}
.upload {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
}
.upload-i {
  width: 59px;
  height: 59px;
  display: block;
  video,
  img {
    width: 100%;
    height: 100%;
  }
}
.uploadBtn {
  margin-top: 7px;
  display: block;
  height: 16px;
  margin-left: auto;
  margin-right: auto;
}
.closeBtn {
  position: absolute;
  right: 20px;
  top: 10px;
  width: 12px;
}
</style>